import { useTranslation } from "react-i18next";
import styles from "./pageNotFound.module.css";

export const PageNotFound = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.notFoundContainer}>
      <div className={styles.notFoundText}>{t("titles.page_not_found")}</div>
      <div className={styles.notFoundCode}>404</div>
    </div>
  );
};
